
define("json!config/locales/en.json", function(){ return {
    "account": {
        "account-main": "Состояние текущего счёта (Сальдо, Дебет+Кредит).",
        "account-credit": "Условный кредит которую предоставляет компания (Сумма кредит компания + кредит менеджера по продажам).",
        "account-limit": "Условная сумма в рамках которого клиент может сделать заказ в системе (Лимит = Счёт + Кредит-Заказ).",
        "account-order": "Сумма заказа сделанного в системе.",
        "account-deposit": " Обеспечительный платеж, единоразово вносимый клиентом."
    }
};});

